<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,

  props: {
    legendPosition: {
      type: String,
      default: 'top',
    },
    labels: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    dataLabel: {
      type: String,
      default: '',
    },
  },

  mounted() {
    const colors = ['#7F77DD', '#AFA9EC', '#378ADD', '#6FAED9', '#9C8ADE', '#CFA6B8', '#E6D8F2', '#EDC1CF'];

    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: this.dataLabel,

            backgroundColor: colors,
            borderColor: '#ffffff',
            borderWidth: 1,

            data: this.data,
          },
        ],
      },

      {
        responsive: true,
        maintainAspectRatio: false,

        legend: {
          position: this.legendPosition,
          display: false,
        },

        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[0];
              const total = dataset.data.reduce((a, b) => a + b, 0);
              const value = dataset.data[tooltipItem.index];
              const percent = ((value / total) * 100).toFixed(1);

              return `${data.labels[tooltipItem.index]}: ${value} (${percent}%)`;
            },
          },
        },

        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    );
  },
};
</script>

<style scoped>
div {
  height: 100%;
}
</style>
